import { render, staticRenderFns } from "./ProspectTab.vue?vue&type=template&id=401c295e"
import script from "./ProspectTab.vue?vue&type=script&lang=js"
export * from "./ProspectTab.vue?vue&type=script&lang=js"
import style0 from "./ProspectTab.vue?vue&type=style&index=0&id=401c295e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports